import { render } from "./PreviewIcon.vue?vue&type=template&id=1663c359"
const script = {}

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__